export enum SourceMap {
    account = "AccountNode",
    folder = "Folder",
    subfolder = "Subfolder",
    favorite = "Favorites"
}
